<template>
    <v-container class="forma-pagamento grey lighten-5">
        <v-row>
            <v-col>
                <v-flex class="text-center" mt-2>
                    <p class="font-weight-bold text--primary text-h5">FORMAS DE PAGAMENTO</p>
                </v-flex>

                <FormaToggle v-model="forma_pagamento" class="mt-5 mx-12" cartao boleto />

                <FormaCartao v-if="forma_pagamento === FormasPagamento.Cartao" v-model="cartao" :bandeiras-base="bandeiras_base" ref="form" class="mt-5">
                    <v-btn block
                           class="mt-7"
                           @click="validarPedido"
                           color="primary">
                        Confirmar Pagamento
                    </v-btn>
                </FormaCartao>

                <v-flex v-if="forma_pagamento === FormasPagamento.Boleto" class="mt-12 text-center">
                    <v-btn color="primary" @click="validarPedido">
                        Confirmar Pagamento
                    </v-btn>
                </v-flex>
            </v-col>

            <v-col class="white" style="border-radius: 4px">
                <p class="ma-2 font-weight-bold grey--text text-h5">DETALHES DA VENDA</p>

                <v-flex class="card-resumo grey lighten-4">
                    <v-layout>
                        <v-flex xs1>
                            <v-icon color="accent">account_balance</v-icon>
                        </v-flex>
                        <v-flex pb-2>
                            <div class="text-h6">{{ pedido.bem.nome_bem }}</div>
                            <small class="dark--text">{{ pedido.plano.nome_plano }} {{ pedido.plano.prazo_comercializacao }} M</small>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="quantidadeCotasVenda > 1">
                        <v-flex offset-xs1 xs7>
                            <span class="text-h6 grey--text">Quantidade de Cotas</span>
                        </v-flex>
                        <v-flex xs4 text-right>
                            <span class="text-h6 primary--text font-weight-bold">{{ quantidadeCotasVenda }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="quantidadeCotasVenda > 1">
                        <v-flex offset-xs1 xs7>
                            <span class="text-h6 grey--text"> Valor Total do Bem </span>
                        </v-flex>
                        <v-flex xs4 text-right>
                            <span class="text-h6 primary--text font-weight-bold">{{ (pedido.bem.valor_bem * quantidadeCotasVenda) | money }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="quantidadeCotasVenda > 1">
                        <v-flex offset-xs1 xs7>
                            <span class="text-h6 grey--text">Valor Total da Primeira Parcela</span>
                        </v-flex>
                        <v-flex xs4 text-right>
                            <span class="text-h6 primary--text font-weight-bold">{{ (pedido.plano.valor_parcela * quantidadeCotasVenda) | money }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex offset-xs1 xs7>
                            <span class="text-h6 grey--text">{{ quantidadeCotasVenda > 1 ? 'Valor Unitário do Bem' : 'Valor do Bem' }}  </span>
                        </v-flex>
                        <v-flex xs4 text-right>
                            <span class="text-h6">{{ pedido.bem.valor_bem | money }}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex offset-xs1 xs7>
                            <span class="text-h6 grey--text">{{ quantidadeCotasVenda > 1 ? 'Valor Unitário da Primeira Parcela' : 'Valor da Primeira Parcela' }}</span>
                        </v-flex>
                        <v-flex xs4 text-right>
                            <span class="text-h6">{{ pedido.plano.valor_parcela | money }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex class="mx-4 my-8">
                    <v-layout wrap>
                        <v-flex xs1>
                            <v-icon color="accent">person</v-icon>
                        </v-flex>
                        <v-flex pb-2>
                            <div class="text-h6">DADOS PESSOAIS</div>
                        </v-flex>
                        <v-flex offset-xs1 xs11>
                            <span class="grey--text">{{ pedido.cliente.pessoa === 'juridica' ? pedido.cliente.razao_social : pedido.cliente.nome_completo }}</span>
                        </v-flex>
                        <v-flex offset-xs1 xs11 mt-1>
                            <span class="grey--text">{{ pedido.cliente.email }}</span>
                        </v-flex>
                        <v-flex offset-xs1 xs11 mt-1>
                            <span class="grey--text">{{ getDocumento(pedido) }}</span>
                        </v-flex>
                        <v-flex offset-xs1 xs11 mt-1>
                            <span class="grey--text">{{ pedido.cliente.telefone_celular | celular }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex class="card-resumo valor-total grey lighten-4 text--accent text-center px-10 py-8">
                    {{ (pedido.plano.valor_parcela * quantidadeCotasVenda ) || 0 | money }}
                    <br />
                    {{ text }}
                    <v-flex v-if="desconto && vl_original > 0" class="litle card-resumo valor-total grey lighten-4 text--accent text-center px-10 py-8">
                        Valor original: {{ (vl_original * quantidadeCotasVenda) || 0 | money }}
                    </v-flex>
                </v-flex>
            </v-col>
        </v-row>

        <DialogConfirmarEmail v-model="dialog_email"
                              :email="pedido.cliente.email"
                              @enviar="finalizar" />
    </v-container>
</template>

<script>
  import FormaPagamento from '@/views/cadastro/pagamento/FormaPagamento'
  import { FormasPagamento } from '@/plugins/constants'
  import { notification } from '@/plugins/helpers'
  import { cnpj, cpf } from '@/plugins/formatters'
  import { BoletoMensagensCliente } from '../../enums/boletos/messages'
  import { AlertTypes } from '@/plugins/alerts_types'

  export default {
    extends: FormaPagamento,
    data: () => ({
      text: 'Valor total a pagar',
      first_time: true,
      hasDesconto: false,
      vl_c_desconto: null,
      vl_original: null,
      quantidadeCotasVenda: 1
    }),
    computed: {
      token () {
        return this.$route.params.token
      },
      bandeiras_base () {
        return this.$route.params.bandeiras_base
      },
      rotas () {
        return {
          vendas: '/pagamento/cliente/' + this.token + '/vendas',
          pagamento: '/pagamento/cliente/' + this.token,
          boleto: '/pagamento/cliente/' + this.token + '/boleto',
          check_desconto: '/pagamento/cliente/' + this.token + '/configuracaopagamento/check'
        }
      }
    },
    watch: {
      pedido () {
        if (this.first_time) {
          this.$http.get(`${this.rotas.check_desconto}/${this.pedido.id_pedido}`)
            .then(res => {
              this.hasDesconto = res.data.desconto
              this.vl_c_desconto = res.data.vl_c_desconto
              this.vl_original = res.data.vl_original
              this.quantidadeCotasVenda = res.data.quantidade_pedidos_link
              this.desconto = (this.hasDesconto)

              if (this.desconto) {
                this.text = 'Valor com desconto'
              } else {
                this.text = 'Valor total a pagar'
              }
            })
          this.first_time = false
          this.vendedor = false
        }
      },

      forma_pagamento (val) {
        if (this.desconto) {
          this.pedido.plano.valor_parcela = parseFloat(this.pedido.bem.vl_c_desconto) > 0 ? this.pedido.bem.vl_c_desconto : this.pedido.bem.vl_original
        }

        if (this.desconto) {
          this.text = 'Valor com desconto'
        } else {
          this.text = 'Valor total a pagar'
        }
      }
    },
    methods: {
      getDocumento (pedido) {
        return pedido.cliente.pessoa === 'juridica' ? 'CNPJ: ' + cnpj(pedido.cliente.cnpj) : 'CPF: ' + cpf(pedido.cliente.cpf)
      },
      async enviarBoleto (email) {
        return this.$http.post(this.rotas.boleto, { id_pedido: this.pedido.id_pedido, email: email, quantidade_cotas_venda: this.quantidadeCotasVenda })
      },
      async finalizar (email) {
        try {
          if (!this.forma_pagamento === FormasPagamento.Cartao) {
            await this.atualizarEmail(email)
          }

          let objPagamento = null

          switch (this.forma_pagamento) {
            case FormasPagamento.Boleto:
              await this.enviarBoleto(email)
              const mensagem = this.quantidadeCotasVenda > 1 ? BoletoMensagensCliente.PAGAMENTO_SUCESSO_BOLETO_MULTIPLO : BoletoMensagensCliente.PAGAMENTO_SUCESSO_BOLETO
              objPagamento = { type: AlertTypes.SUCCESS, mensagem }
              break
            case FormasPagamento.Cartao:
              objPagamento = await this.enviarCartao()
              break
          }

          this.pedido.enviado = true
          if (objPagamento) {
            notification(objPagamento.type, objPagamento.mensagem, '', false, false, true)
          }
          this.$emit('finalizado')
          this.$session.destroy()
          this.$router.replace({ name: 'cliente-login' })
        } catch (err) {
          notification(AlertTypes.ERROR, err.message)
        }
      }
    }
  }
</script>

<style lang="scss">
    .forma-pagamento {
        .theme--light.m-text-field--outlined > .v-input__control > .v-input__slot {
            background-color: white !important;
        }
    }
</style>

<style scoped lang="scss">
    .forma-pagamento {
        max-width: 1000px;
    }

  .litle {
    font-size: 15px !important;
  }

    .box {
        width: 55px;
        height: 45px;
        background: #fff;
        border-radius: 10px;
    }

    .title {
        color: var(--accent);
        font-size: 16px;
    }

    .card-resumo {
        border-radius: 10px;
        margin: 10px;
        padding: 30px;
    }

    .valor-total {
        font-size: 1.5rem;
    }
</style>
